import React from 'react';
import { Link } from 'react-router-dom';
import WaitlistForm from '../../components/marketing/WaitlistForm';
import { COMPANY } from '../content/company';
import { FOOTER_COLUMNS, FOOTER_LEGAL, FOOTER_WAITLIST_LABEL } from '../content/footer';

interface FooterProps {
  /** PUBLIC_SITE=hero: only the legal line survives (the columns link to redirected routes). */
  heroOnly: boolean;
}

export default function Footer({ heroOnly }: FooterProps) {
  const year = new Date().getFullYear();
  return (
    <footer className="mk-footer">
      <div className="mk-container">
        {!heroOnly && (
          <div className="mk-footer__grid">
            <div>
              <p className="mk-footer__label t-details">Contact</p>
              <div className="mk-footer__contact t-body">
                <p>
                  <a href={`mailto:${COMPANY.email}`}>{COMPANY.email}</a>
                </p>
                <p>
                  <a href={`tel:${COMPANY.phone}`}>{COMPANY.phoneDisplay}</a>
                </p>
                <address className="mk-footer__address">
                  <span className="t-details t-muted">Registered office</span>
                  {[COMPANY.legalName, ...COMPANY.registeredOffice].map((line) => (
                    <span key={line}>{line}</span>
                  ))}
                </address>
              </div>
            </div>

            {FOOTER_COLUMNS.map((column) => (
              <div key={column.label}>
                <p className="mk-footer__label t-details">{column.label}</p>
                <ul className="mk-footer__list t-body">
                  {column.links.map((link) => (
                    <li key={link.to}>
                      <Link to={link.to}>{link.label}</Link>
                    </li>
                  ))}
                </ul>
              </div>
            ))}

            {/* The only capture on the pages without a band of their own; on
                every public page, and close to free. Unchanged component. */}
            <div>
              <p className="mk-footer__label t-details">{FOOTER_WAITLIST_LABEL}</p>
              <WaitlistForm sourceSurface="footer" variant="footer" />
            </div>
          </div>
        )}

        <div className="mk-footer__bottom t-details">
          <p>
            &copy; {year} {COMPANY.legalName} &middot; Registered in {COMPANY.registeredIn}
            {COMPANY.companyNumber ? ` · Company number ${COMPANY.companyNumber}` : ''}
          </p>
          <div className="mk-footer__legal">
            {FOOTER_LEGAL.map((link) => (
              <Link key={link.to} to={link.to}>
                {link.label}
              </Link>
            ))}
          </div>
        </div>
      </div>
    </footer>
  );
}
